<template>
    <div
        class="ppv2-mb-6 ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2 lg:ppv2-grid-cols-4"
        :style="{ gap: normalizeSize(16, true) }"
    >
        <!-- Factures émises -->
        <div class="ppv2-rounded-lg ppv2-bg-white ppv2-p-4 ppv2-border ppv2-border-gray-200 ppv2-shadow-sm">
            <div class="ppv2-text-xs poppinsMedium ppv2-mb-1 ppv2-text-gray-500 ppv2-uppercase">
                {{ $t('invoices.stats.invoices_count') }}
            </div>
            <div class="ppv2-text-2xl poppinsBold ppv2-text-gray-900">
                {{ stats?.invoices_count || 0 }}
            </div>
        </div>

        <!-- Total facturé -->
        <div
            class="ppv2-rounded-lg ppv2-bg-gradient-to-br ppv2-from-blue-600 ppv2-to-blue-700 ppv2-p-4 ppv2-text-white ppv2-shadow-sm"
        >
            <div class="ppv2-text-xs poppinsMedium ppv2-mb-1 ppv2-opacity-90 ppv2-uppercase">
                {{ $t('invoices.stats.total_invoiced') }}
            </div>
            <div class="ppv2-text-2xl poppinsBold">
                {{ stats?.total_invoice?.formatted || '0.00' + $symbolCurrency }}
            </div>
        </div>

        <!-- Payé -->
        <div
            class="ppv2-rounded-lg ppv2-bg-gradient-to-br ppv2-from-emerald-600 ppv2-to-emerald-700 ppv2-p-4 ppv2-text-white ppv2-shadow-sm"
        >
            <div class="ppv2-text-xs poppinsMedium ppv2-mb-1 ppv2-opacity-90 ppv2-uppercase">
                {{ $t('invoices.stats.paid') }}
            </div>
            <div class="ppv2-text-2xl poppinsBold">
                {{ stats?.total_validated_invoice?.formatted || '0.00' + $symbolCurrency }}
            </div>
        </div>

        <!-- Taux d'encaissement -->
        <div
            class="ppv2-rounded-lg ppv2-bg-gradient-to-br ppv2-from-purple-600 ppv2-to-purple-700 ppv2-p-4 ppv2-text-white ppv2-shadow-sm"
        >
            <div class="ppv2-text-xs poppinsMedium ppv2-mb-1 ppv2-opacity-90 ppv2-uppercase">
                {{ $t('invoices.stats.transformation_rate') }}
            </div>
            <div class="ppv2-text-2xl poppinsBold">
                {{ stats?.rate_transformation || '0 %' }}
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'

export default {
    name: 'InvoiceStatsCards',
    props: {
        startDate: {
            type: String,
            default: () => new Date().toISOString().split('T')[0],
        },
        endDate: {
            type: String,
            default: () => new Date().toISOString().split('T')[0],
        },
    },
    data() {
        return {
            stats: null,
            loading: false,
            error: null,
        }
    },
    mounted() {
        this.loadStats()
    },
    watch: {
        startDate() {
            this.loadStats()
        },
        endDate() {
            this.loadStats()
        },
    },
    methods: {
        normalizeSize,
        async loadStats() {
            this.loading = true
            this.error = null

            try {
                console.log(this.startDate)
                console.log(this.endDate)
                const response = await this.axios.post('/back-office/invoices-v2/stats', {
                    startDate: this.startDate,
                    endDate: this.endDate,
                })
                this.stats = response.data
                console.log('📊 Statistiques chargées:', this.stats)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.error = error.message
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped></style>
